import { combineEpics } from 'redux-observable';

import form from './form';
import socialRsvp from './socialRsvp';
import dateRange from './dateRange';

export default combineEpics(form, socialRsvp, dateRange);
